/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

import LoadingSpinner from 'components/LoadingSpinner';
import Header from 'components/Header';
import ExpiryWarning from 'components/ExpiryWarning';
import Footer from 'components/Footer';
import CustomersForm from 'views/CustomersForm';
import { ROUTES } from 'enum';
import { getCustomerList, removeCurrentCustomer } from 'store/customers/actions';

import './organizations.scss';

const Organizations = ({ removeCurrentCustomer, getCustomerList }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const getCustomers = useCallback(async () => {
    try {
      setLoading(true);
      const customers = await getCustomerList();
      if (!customers || !customers.length) {
        history.push(ROUTES.ORG_INFO);
      }
      if (customers.length === 1 && (!location.state || !location.state.from)) {
        history.push(`${ROUTES.CUSTOMERS}/${customers[0].uuid}/ecosystems`);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [getCustomerList, history, location.state]);

  useEffect(() => {
    removeCurrentCustomer();
    getCustomers();
  }, [getCustomers, removeCurrentCustomer]);

  // useEffect(() => {
  //   removeCurrentCustomer();
  // }, [removeCurrentCustomer]);

  return (
    <>
      <Helmet>
        <title>Organizations - Sectrify</title>
      </Helmet>
      <div className="wrapper organizations-wrapper">
        <ExpiryWarning />
        <Header brandText="All Organizations" />
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <Box sx={{ width: '100%', bgcolor: '#f9f9f9' }}>
                <CustomersForm />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ fontSize: '18px' }}
                  onClick={() => history.push(ROUTES.ORG_INFO)}
                >
                  Add new
                </Button>
              </Box>
            </>
          )}
        </Box>
        <Footer />
      </div>
    </>
  );
};

Organizations.propTypes = {
  removeCurrentCustomer: PropTypes.func.isRequired,
  getCustomerList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  customers: state.customers.customers,
});

const mapDispatchToProps = (dispatch) => ({
  removeCurrentCustomer: () => dispatch(removeCurrentCustomer()),
  getCustomerList: () => dispatch(getCustomerList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Organizations);
